import { render, staticRenderFns } from "./block-info-element.vue?vue&type=template&id=760433b3"
import script from "./block-info-element.vue?vue&type=script&lang=js"
export * from "./block-info-element.vue?vue&type=script&lang=js"
import style0 from "./block-info-element.vue?vue&type=style&index=0&id=760433b3&prod&module=true&lang=sass"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports